window.onresize = checkKeyfeaturesMobileSlider;
document.addEventListener("DOMContentLoaded", function() {
    checkKeyfeaturesMobileSlider();
  }) 

  var sliderSettingsPK = {
    onDragged: sliderDragCallback,
    loop: true,
    dots: true,
    dotsEach: true,
    autoWidth: false,
    autoHeight: true,
    items:1.2,
    margin:0,
    nav: false,
    responsive: {
      0: {
        items: 1.3,
        center: false,
        margin: 20,
      },
      751: {
        items: 1.2,
        center: false,
        margin: 20,
      }
    }
  }
  
  
  function checkKeyfeaturesMobileSlider(){
    let x = '.product-keyfeatures-wrap .features_wrap';

    let isMobile = window.innerWidth < 1001 ? true : false;
    if(isMobile){
      $(x).addClass('owl-carousel').addClass('owl-theme');
      $(x).owlCarousel(sliderSettingsPK).trigger('refresh.owl.carousel');
      
    } else{
      $(x).owlCarousel('destroy')
      $(x).removeClass('owl-carousel').removeClass('owl-theme');
    }
    
  }
  
  function keyFeauresPoint(e, idx){
    // Init
    $('.product-keyfeatures-wrap .point').removeClass('active')
    $(e).addClass('active');
    $(`.product-keyfeatures-wrap .features .features_texts .content`).addClass('hide');

    // Point active
    $(`.product-keyfeatures-wrap .point`).removeClass('active');
    $(`.product-keyfeatures-wrap .point[data-idx="${idx}"]`).addClass('active')

    let dotToClick = $(`.product-keyfeatures-wrap .owl-dots .owl-dot:nth-child(${idx})`);

    // Slider activation
    $(`.product-keyfeatures-wrap .owl-dots .owl-dot:nth-child(${idx})`).click();

     // Show content
    $(`.product-keyfeatures-wrap .features[data-idx="${idx}"] .features_texts .content`).removeClass('hide')
      
   
  }

  function sliderDragCallback(){
    let currentActiveIdx = $($('.product-keyfeatures-wrap .features_wrap .owl-item.active')[0]).find('.point').attr('data-idx')
      
    // Point active
    $(`.product-keyfeatures-wrap .point`).removeClass('active');
    $(`.product-keyfeatures-wrap .point[data-idx="${currentActiveIdx}"]`).addClass('active')
    
  }